import { useState, useEffect } from 'react'

import { fetchPage } from '../../utils/Utils'

import styles from './Terms.module.css';

const Terms = () => {
  const [page, setPageData] = useState(null);

  useEffect(() => {
    const getNavigation = async () => {
      try {
        const pageData = await fetchPage('terms-and-conditions');
        setPageData(pageData);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    getNavigation();
  }, []
  );

  return (
    <>
      {page ? (
        <div className={styles['page-content-wrapper']} dangerouslySetInnerHTML={{ __html: page?.content.rendered }}></div>
      ) : (
        <p className='loading'></p>
      )}
    </>
  )
}

export default Terms